@if (activeVariant.description) {
  <div class="description-wrapper">
    <span class="title" *transloco="let t">{{ t('Details') }}</span>

    <div class="details">
      @for (property of properties; track property.name) {
        <p>{{ property.description }}: {{ property.value }}</p>
      }
      <br />
      <div [innerHTML]="description"></div>
      <br />

      @if (activeVariant.variantSku) {
        <p class="sku">SKU: {{ activeVariant.variantSku }}</p>
      }
    </div>
  </div>
}
